import React, { useRef, useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import './uploadeditfilesandimages.css'
import { AiFillCloseCircle, AiOutlineCheckCircle } from 'react-icons/ai'
import { BsUpload } from 'react-icons/bs'
import { RiImageAddLine } from 'react-icons/ri';
import { uploadFilesAndImagesAPI } from '../../../common/apiService'
import SubmittedPopup from './submittedPopup'
import { validateFileTypeAndSize } from '../../../service/utilService';



export default function UploadEditFilesAndImages({ showuploadmodel, setShowUploadModel, setLoading }) {

    const imageInput = useRef();
    const fileInput = useRef();
    const [fileaname, setFileaName] = useState("Upload file");
    const [file, setFile] = useState([]);
    const [imagename, setImageName] = useState("Upload images");
    const [image, setImage] = useState([]);
    const [enableBtn, setEnableBtn] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);


    useEffect(() => {
        setEnableBtn(file[0] && image[0] ? true : false)
    }, [file, image])


    const uploadImage = () => {
       const image = imageInput.current.files;
       let valid = true;
        for(let i=0; i<image.length; i++){
            let status = validateFileTypeAndSize([image[i]], "image", 2);
            if(!status){
               valid=false;
               break; 
            }
        }
      
       if(valid){
        setImageName(image[0] ? image.length + " image selected" : "Upload images");
        setImage(image);
       }
    }

    const uploadFile = () => {
        const file = fileInput.current.files;
        const valid = validateFileTypeAndSize(file,"excel",50);
        if(valid){
        setFileaName(file[0] ? file[0].name : "Upload file");
        setFile(file);
        }
    }
    

    const [response, setResponse] = useState({})

    const uploadFilesAndImages = async () => {
        setLoading(true);
        const formdata = new FormData();
        formdata.append("file", file[0])
        for (let i = 0; i < image.length; i++) {
            formdata.append("file", image[i]);
        }
        const { data } = await uploadFilesAndImagesAPI(formdata);
        setLoading(false);
        setResponse(data);
        reset();
        setShowSuccessPopup(true);
    }

     const reset = ()=>{
         setFile([]);
         setFileaName("Upload file");
         setImageName("Upload images");
         setImage([]);
         setShowUploadModel(false);
     }

    return (
        <>
            <SubmittedPopup
                response={response}
                showSuccessPopup={showSuccessPopup}
                setShowSuccessPopup={setShowSuccessPopup}
            />

            <Modal show={showuploadmodel} size="lg" className="" centered onHide={reset}>
                <Modal.Header>
                    <Modal.Title>
                        <span className="upload-popup-title1">Upload edited files &amp; images</span>
                        <p className="upload-popup-title2">Upload edited xls file with images name &amp; respective possible matching images</p>
                    </Modal.Title>
                    <AiFillCloseCircle className="reasonmodalclosebtn" onClick={reset} />
                </Modal.Header>
                <Modal.Body>
                    <div className="flex-block">
                        <label htmlFor="upload-files">
                            {fileaname === 'Upload file' ?
                                <> <BsUpload /><br /> <span style={{ fontSize: 22 }}> {fileaname}</span> </> :
                                <>  <AiOutlineCheckCircle className="checkIcon" /><br /> <span style={{ fontSize: 12 }}> {fileaname}</span></>
                            } <br />
                        </label>
                        <label htmlFor="upload-images">
                            {imagename === 'Upload images' ?
                                <> <RiImageAddLine /> <br /><span style={{ fontSize: 22 }}> {imagename} </span> </> :
                                <> <AiOutlineCheckCircle className="checkIcon" /> <br /><span style={{ fontSize: 12 }}> {imagename} </span> </>
                            }
                            <br />
                        </label>
                        <input type="file" name="" id="upload-files" accept=".xlsx, .xls" ref={fileInput} onChange={uploadFile} style={{ display: 'none' }} />
                        <input type="file" name="" id="upload-images" accept=".jpg, .jpeg, .png"  ref={imageInput} multiple="true" onChange={uploadImage} style={{ display: 'none' }} />
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <div className="upload-popup-btns">
                        <button style={{ backgroundColor: '#707070' }} onClick={reset}>Cancel</button>
                        <button style={{ backgroundColor: '#303A78' }} disabled={!enableBtn} onClick={uploadFilesAndImages}>Submit</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}
